import { zodTransformFirestoreTimestampToDate } from "../utils/zodUtils.mjs";
import { zodFlavorId } from "./ids.mjs";
import { z as z$1 } from "zod";

// src/models/userChoices.ts
const USER_CHOICES_CURRENT_DOCUMENT_ID = "current";
const planSelectedOnSignupSchema = z$1.enum(["Community", "Community + Consults"]);
const userChoicesSchema = z$1.object({
	id: zodFlavorId(),
	planSelectedOnSignup: planSelectedOnSignupSchema.optional(),
	createdAt: z$1.any().transform(zodTransformFirestoreTimestampToDate),
	updatedAt: z$1.any().transform(zodTransformFirestoreTimestampToDate)
});

export { USER_CHOICES_CURRENT_DOCUMENT_ID, planSelectedOnSignupSchema, userChoicesSchema };
//# sourceMappingURL=userChoices.mjs.map